import { connect } from 'react-redux';
import HomePage from './component';
import { getRachelDashboard } from '@renter-hub/actions/requests';
import { showPageNotification } from '@common/actions/NotificationActions';
import { checkRequestActionSuccess, getSignInPage } from '@common/paymentsUtils/api';
import { DEFAULT_ERROR } from '@renter-hub/constants/notifications';
import HTTP_STATUS from '@common/constants/HttpConstants';
import paths from '@renter-hub/pathsManifest';
import type { ErrorInterface } from '@common/types';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state) => ({
  ...state.payments.renter.dashboard,
  location: state.router.location,
  config: state.payments.renter.config,
});

export const buildRequestRenterStatus = (dispatch, inviteToken?: string) => async () => {
  try {
    // Request the latest renter status
    const [renterStatusResponse] = await dispatch(getRachelDashboard({ encryptedInvite: inviteToken }));
    await checkRequestActionSuccess(renterStatusResponse);
    return { error: false };
  } catch (err) {
    const error = err as ErrorInterface;
    if (error.action && error.action.payload) {
      const { status } = error.action.payload;
      // If 401 status, redirect to sign-in
      if (status === HTTP_STATUS.SC_UNAUTHORIZED) {
        window.location = getSignInPage();
        return null;
      }
      // If 400 status, redirect renters to Your Rental.
      if (status === HTTP_STATUS.SC_BAD_REQUEST) {
        window.location.href = paths.yourRentalPage;
        return null;
      }
    }
    logError({ error: err });
    dispatch(showPageNotification(DEFAULT_ERROR));
    return { error: true };
  }
};

const mapDispatchToProps = (dispatch, { brand, inviteToken }) => ({
  requestRenterStatus: buildRequestRenterStatus(dispatch, inviteToken),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
